(() => {
  const dialog = document.getElementById('milo-email-welcome');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const delay = 60000;
  const cooldown = 60 * 60 * 1000;
  const visitKey = 'mm_welcome_last_visit_v2';
  const shownKey = 'mm_welcome_last_shown_v2';
  const signupKey = 'mm_welcome_subscribed_v2';
  const startKey = 'mm_welcome_journey_v2';
  const engagedKey = 'mm_welcome_engaged_v3';
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, String(value)); return true; } catch { return false; } };
  let durable, session;
  try { durable = window.localStorage; session = window.sessionStorage; } catch { return; }
  let previousFocus;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    write(durable, shownKey, Date.now());
    write(session, startKey, 0);
    dialog.showModal();
  };
  dialog.querySelectorAll('[data-mm-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus(); });
  if (dialog.querySelector('[data-mm-success]')) { write(durable, signupKey, 1); open(); return; }
  if (dialog.querySelector('[data-mm-error]')) { open(); return; }
  if (window.Shopify && window.Shopify.designMode) return;
  if (location.pathname.includes('/cart') || location.pathname.includes('/checkout')) return;
  const now = Date.now();
  const lastVisit = Number(read(durable, visitKey));
  const lastShown = Number(read(durable, shownKey));
  let started = Number(read(session, startKey));
  if (!write(durable, visitKey, now) || !write(session, 'mm_welcome_storage_check', 1)) return;
  const rememberVisit = () => write(durable, visitKey, Date.now());
  window.addEventListener('pagehide', rememberVisit);
  if (read(durable, signupKey)) return;
  if (lastShown && now - lastShown < cooldown) return;
  if (!started || started > now || now - started >= cooldown) {
    if (lastVisit && now - lastVisit < cooldown) return;
    started = now;
    write(session, startKey, started);
    write(session, engagedKey, 0);
  }
  let engaged = read(session, engagedKey) === '1';
  let ready = false;
  let timer;
  const focusedOnForm = () => document.activeElement && document.activeElement.closest('form, dialog');
  const maybeOpen = () => {
    if (!engaged || !ready || document.visibilityState !== 'visible' || focusedOnForm()) return;
    if (document.querySelector('dialog[open], [aria-modal="true"], .menu-toggle[aria-expanded="true"]')) return;
    const shown = Number(read(durable, shownKey));
    if (read(durable, signupKey) || (shown && Date.now() - shown < cooldown)) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (!focusedOnForm() && document.visibilityState === 'visible' && !document.querySelector('dialog[open], [aria-modal="true"], .menu-toggle[aria-expanded="true"]')) open();
    }, 1800);
  };
  window.addEventListener('scroll', () => {
    clearTimeout(timer);
    if (window.scrollY >= Math.max(250, window.innerHeight * .6)) {
      engaged = true;
      write(session, engagedKey, 1);
      maybeOpen();
    }
  }, { passive: true });
  document.addEventListener('click', event => {
    if (event.target.closest('main a[href*="/products/"], main a[href="#our-toys"]')) write(session, engagedKey, 1);
  });
  document.addEventListener('visibilitychange', maybeOpen);
  document.addEventListener('focusout', maybeOpen);
  setTimeout(() => { ready = true; maybeOpen(); }, Math.max(0, delay - (now - started)));
})();
